import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'

import { GridItem } from 'partials/UpspaceTabs/widgets/subcomponents/GridItem'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'
import { LoadingSpinner } from 'widgets/LoadingSpinner'

import { Post } from 'types/post'

interface PostsGridViewProps {
  isLoading: boolean
  onEndReached?: () => void
  posts: Post[]
  columns?: 2 | 3
  showCompactItems?: boolean
}

export const PostsGridView = ({
  isLoading,
  onEndReached,
  posts,
  columns,
  showCompactItems,
}: PostsGridViewProps): JSX.Element => {
  const theme = useTheme()

  const styles = StyleSheet.create({
    flatList: {
      paddingBottom: theme.spacing.lg,
      paddingHorizontal: 8,
      paddingTop: 12,
    },
  })

  return (
    <Box flex={1}>
      <FlatList<Post>
        numColumns={columns}
        data={posts}
        loading={isLoading}
        renderItem={({ item: post, index }) => (
          <GridItem
            post={post}
            isLast={index === posts.length - 1}
            isCompact={showCompactItems ?? !!columns}
          />
        )}
        onEndReached={onEndReached && onEndReached}
        keyExtractor={(post) => {
          return post.id
        }}
        style={styles.flatList}
        noContentProps={{
          message: 'No posts to show',
        }}
        ListFooterComponent={isLoading ? <LoadingSpinner /> : null}
      />
    </Box>
  )
}
